import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs/';

@Injectable()
export class FullscreenService {

    private fullscreen = new BehaviorSubject<any>(null);

    constructor() {
        this.init();
    }

    private init() {
        Observable.merge(
            Observable.fromEvent(document, 'webkitfullscreenchange'),
            Observable.fromEvent(document, 'mozfullscreenchange'),
            Observable.fromEvent(document, 'fullscreenchange'),
            Observable.fromEvent(document, 'MSFullscreenChange')
        )
        .subscribe(_ => {
            if (this.fullscreen.getValue() && !this.isFullscreen()) {
                this.exitFullscreen();
            }
        });
    }

    private isFullscreen(): boolean {
        let fullscreenElement = document.fullscreenElement || document['mozFullScreenElement'] ||
          document.webkitFullscreenElement || document['msFullscreenElement'];
        return fullscreenElement != null;
        /*return !!document['fullscreen'] ||
                !!document['webkitIsFullScreen'] ||
                !!document['mozFullScreen'] ||
                !!document['msFullscreen'];*/
    }

    public enterFullscreen(element: any) {
        this.fullscreen.next(element);
        this.launch(element);
    }

    public exitFullscreen() {
        this.fullscreen.next(null);
        this.exit();
    }

    public onFullscreen(): Observable<boolean> {
        return this.fullscreen.do(_ => console.log('emittin')).map(val => !!val);
    }

    private launch(element: any) {
        if (element.requestFullscreen) {
            element.requestFullscreen();
        } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
        }
    }

    private exit() {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document['mozCancelFullScreen']) {
            document['mozCancelFullScreen']();
        }else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document['msExitFullscreen']) {
          document['msExitFullscreen']();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/fullscreen.service.ts